<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">고령임신</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">조기진통,조산</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">임신중 고혈압성 질환</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">임신성 당뇨</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">전치태반</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">자궁경부무력증</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">다태임신</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==8}" @click="lnbFn(8)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step8')">태아치료</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==9}" @click="lnbFn(9)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step9')">산후 출혈</a>
                </li>
            </ul>
        </div>
        <div class="info">
            <div class="botton-wrap right type02">
                <a href="https://www.momg1.co.kr" target="_blank" title="새창열림" class="main-button c-main">고위험임산부 지원금 확인</a>
            </div>
        </div>
        <div id="step1" class="step-item info">
            <h3 class="bullet01">고령임신</h3>
            <p class="depth">
                최근 경제력이 높아지고 만혼의 빈도가 증가함에 따라 임신과 분만의 적령기를 지나 결혼하거나, 여러 가지 이유로 늦게 출산하는 여성의 수가 증가 하고 있습니다. 
                <br>
                고령 임산부는 초산 여부에 상관없이 35세가 넘어 임신한 여성을 정의하고 있으며, 이를 고위험 임신부로 간주하고 우리나라도 35세 이상 임산부가 전체 임산부 가운데 차지하는 비율이 점차 증가하고 있습니다. 
                <br>
                고령 임산부는 젊은 임산부보다 유산, 선천성기형, 고혈압, 임신중독증, 자궁근종, 태아위치이상, 난산, 기계분만, 제왕절개술, 저체중아 출산, 조산 등의 발생빈도가 더 높으며, 신생아 이환율과 신생아 사망률이 더 증가하는 것으로 알려져 있습니다. 
                <br>
                이러한 35세 이상의 고령 임산부는 전문가를 찾아 적절한 상담과 관리를 받는다면 건강한 임신, 안전한 분만이 가능합니다. 
            </p>
            <h4 class="bullet02 type2 num1 depth">정기적으로 건강검진을 받습니다.</h4>
            <p class="depth">
                미처 알지 못했던 질환이 없는지 다른 문제는 없는지 충분히 심신이 건강한 상태에 계획된 임신을 하면 건강한 임신과 출산이 가능합니다.
            </p>

            <h4 class="bullet02 type2 num2 depth">정기적인 산전검사를 합니다.</h4>
            <p class="depth">
                고령임신은 젊은 임산부에 비하여 기형아를 출산할 확률이 약 1.5배 높습니다. 초기 기형아 선별검사와 융모막과 양수 검사를 통해 태아 염색체 이상을 확인 할 수 있습니다. -또한 초음파를 통하여 태아의 이상여부를 확인하여 향 후 치료와 출산계획을 세울 수 있습니다.
            </p>

            <h4 class="bullet02 type2 num3 depth">정기 산전관리로 임신 합병증을 예방합니다.</h4>
            <p class="depth">
                고령임신은 여러 가지 임신으로 인한 합병증 발생우려가 높습니다. 임신성 고혈압, 임신성 당뇨 발생 비율이 높아짐에 따라 임신 중 체중관리와 식이관리가 더욱더 중요해집니다. -적절한 운동으로 임신 중 체중 증가에 신경을 쓰고 맵거나 짠 음식을 절제하여 임신으로 인한 합병증을 예방하도록 합니다.
            </p>
        </div>

        <div id="step2" class="step-item info">
            <h3 class="bullet01">조기진통, 조산</h3>
            <p class="depth">
                약 10%의 임산부에서 조산이 발생하며 이렇게 태어난 미숙아는 태아의 성장과 발육에 지대한 장애를 초래할 수 있고, 또한 출생 후에도 수년간 성장에 장애를 가져올 수도 있습니다. 조산예방 클리닉에서는 조기진통의 조짐을 조기 발견함으로써 적절한 치료를 일찍 시작하여 조산을 예방하는 노력을 하고 있습니다.
                <br>
                임신부의 임신 주수, 태아 수와 상태 등을 면밀히 파악해 개인별 상황에 맞도록 자궁경부를 묶어주는 자궁경부 결찰술이나 프로게스테론 요법을 선택하여 조산을 예방하고 치료합니다. 무엇보다 중요한 산전 관리, 약물 치료, 수술 치료에 대한 교육과 상담 등을 제공하고 있습니다.
            </p>
            <h4 class="bullet02 type2 num1 depth">조산의 원인</h4>
            <p class="bullet04 num1 depth">1/3은 합병증에 의한 조산</p>
            <p class="bullet05 depth">조산의 약1/3은 태반출혈과 고혈압성 질환에 의한 불가피한 조산이며 나머지 2/3은 조기 양막파수가 있건 없건 자연적으로 생긴 조기진통에 의한 것입니다. </p>
            <p class="bullet04 num2 depth">잘못된 생활습관도 조산의 원인</p>
            <p class="bullet05 depth">
                흡연, 음주, 분별없는 약물복용, 영양섭취부족 또는 정상에서 벗어나는 체중 증가 등이 저 체중 신생아의 원인이 됩니다. 그 중에서 특히 산모의 체중 증가가 정상적이지 못한 점은 조산의 위험을 높이는 중요한 원인입니다. 또한 음주는 조산뿐만 아니라 뇌 손상을 줄 수 있는 위험성도 가지고 있습니다.
            </p>
            <p class="bullet04 num3 depth">양수의 세균감염이 조기진통의 한 원인</p>
            <p class="bullet05 depth">
                양수가 각종 세균에 감염되면 아무런 증상이 없다가도 갑자기 양수가 파열되고 조기진통이 올 수 있습니다. 양수천자를 해 보면 양막이 파열되지 않고 오는 조기진통의 약 20%에서 세균이 발견되고 있습니다. 또 임신 28주~35주 사이에 양수가 파열된 산모의 양수를 검사해본 결과 약 25%에서 세균이 발견되었습니다.
            </p>
            <p class="bullet04 num4 depth">세균성 질염으로 조산이 생길 수도</p>
            <p class="bullet05 depth">
                질 내에서 성장하는 정상적인 유익균 락토산 간균이 줄어들고 다른 유해균이 번식하여 질염을 일으킬 수 있는데 이런 경우 조산, 조기양막 파수, 양수 감염이 올 수 있습니다. 하지만 모든 균이 다 조산을 유발하지는 않습니다.
            </p>
            <h4 class="bullet02 type2 num2 depth">조기진통 증상과 응급 대처법</h4>
            <p class="depth">
                골반에 압력감을 느끼게 되고, 생리통과 비슷한 복통, 혈액 혹은 물 같은 분비물이 질에서 분비되면서 하부 요통이 오면 조산이 임박하였음을 시사하는 증상일 수 있으므로 즉시 내원하여 담당전문의와 상담하고 필요한 경우 입원 치료를 해야 합니다.
            </p>
            <h4 class="bullet02 type2 num3 depth">조산 고위험군</h4>
            <p class="bullet04 num1 depth">지난 번 임신했을 때 조기진통이나 조산의 경험이 있는 산모</p>
            <p class="bullet04 num2 depth">산모가 심장병, 신장염, 매독, 암신중독증, 전치태반, 양수과다 등의 질환이 있을 때</p>
            <p class="bullet04 num3 depth">자궁기형, DES 사용력, 쌍태아 등으로 인한 자궁확장, 조기파</p>
            <p class="bullet04 num4 depth">18세 미만의 어린 산모</p>
            <p class="bullet04 num5 depth">35세 이상의 고령 산모</p>
            <p class="bullet04 num6 depth">신체적, 정신적 스트레스가 심한 경우</p>
            <p class="bullet04 num7 depth">신장이나 요로 감염증이 심한 경우</p>
            <p class="depth mt20">
                <b>위와 같은 사항에 해당되는 임신부는 조산의 가능성을 염두에 두고 조기진통이 생기는지 세심히 관찰해야합니다.</b>
            </p>
        </div>

        <div id="step3" class="step-item info">
            <h3 class="bullet01">임신중 고혈압성 질환</h3>
            <h4 class="bullet02 type2 num1 depth">임신성 고혈압은 임신 20주 이후에 생깁니다.</h4>
            <p class="bullet04 num1 depth">고혈압만 있는 경우</p>
            <p class="bullet04 num2 depth">고혈압에 동반하여 단백뇨나 병적인 부종이 있는 경우(전자간증-임신중독증)</p>
            <p class="bullet04 num3 depth">고혈압에 동반하는 단백뇨나 병적인 부종이 있으면서 발작이 동반되는 경우(자간증)으로 분류할 수 있습니다.</p>
            <h4 class="bullet02 type2 num2 depth">진단</h4>
            <p class="bullet04 num1 depth">임신 중기 이후에 수축기 혈압 140mmHg 이상 또는 확장기 혈압 90mmHg 이상인 경우 고혈압을 진단할 수 있습니다. 임신중독증의 경우는 이러한 고혈압과 함께 24시간 모은 소변에서 300mg이상의 단백뇨가 보이는 경우 또는 소변스틱 검사에서 1+이상의 단백뇨가 함께 보이는 경우에 진단합니다. 자간증은 이와 더불어 경련을 동반했을 경우 진단할 수 있습니다. </p>
            <p class="bullet04 num2 depth">단백뇨는 고혈압이나 체중증가보다 다소 늦게 나타나는 경향을 보이며 임신시 부종의 경우는 정상적으로도 흔하게 나타나기 때문에 부종이 있다고 해서 반드시 전자간증이라고 진단할 수는 없습니다.</p>
            <p class="bullet04 num3 depth">임신 20주 이전에 고혈압이 발생하거나 분만 후 12주까지도 고혈압이 지속되는 경우에는 만성 고혈압으로 진단합니다.</p>
            <h4 class="bullet02 type2 num3 depth">치료</h4>
            <p class="bullet04 num1 depth">전자간증 치료는 산모와 태아에게 합병증을 최소화하도록 적절한 시기에 분만하는 것입니다. 임신 전, 임신 초기부터 철저한 관리를 통해 예방이 무엇보다 중요합니다.</p>
            <p class="bullet04 num2 depth">수축기 혈압이 160mmHg 이상 또는 확장기 혈압 110mmHg이상 단백뇨가 일정량 이상, 두통, 시력장애, 상부 복통, 소변량 감소, 경련 등의 증상이 있거나 혈소판이상, 간기능 이상, 태아발육지연, 폐부종이 동반되는 경우는 중증 전자간증에 해당하며 이 경우 즉각적인 분만을 고려해야합니다. 심한 두통, 상복부 통증, 시력장애를 동반할 수 있고 시력장애의 경우 일시적인 실명이 오기도 하지만, 대부분의 경우에는 수술적 치료 없이 분만 후 수주일 내에 회복됩니다.</p>
            <p class="bullet04 num3 depth">입원치료: 고혈압이 지속되거나 단백뇨가 발생하는 경우 입원을 고려할 수 있습니다. 안정을 취하게 되며, 중증도의 경우는 경련과 뇌출혈을 막기 위해 마그네슘제제를 사용할 수 있으며, 필요한 경우 혈압 강하제를 사용하며 태아의 조기 분만을 고려해야 하는 경우 태아의 폐 성숙을 촉진시키는 약물을 사용할 수 있습니다.</p>
            <p class="bullet04 num4 depth">분만: 전자간증이라고 하여 반드시 제왕절개를 해야 하는 것은 아닙니다. 입원 후에도 호전되지 않거나 악화되는 고혈압인 경우 산모 및 태아의 건강을 위해 분만을 고려하게 되나 이때 산모의 자궁경부의 상태 및 태아의 상태 등 여러 상황을 고려하여 질식분만 할지 제왕절개를 할지 결정하게 됩니다.</p>
            <h4 class="bullet02 type2 num4 depth">분만 후 관리</h4>
            <p class="depth">분만 후 임산부의 건강이 비교적 빠른 시일내에 회복되어 고혈압이 있더라도 퇴원 가능합니다. 대부분은 2 주 이내 혈압이 정상으로 돌아오고 분만 후 1주 이상 지나면 소변양이 많아지면서 단백뇨와 부종도 대부분 사라집니다. 그러나 만약 고혈압이 분만 후 3주 이후에도 지속되는 경우에는 만성 고혈압이 될 가능성이 있으므로 전문의와의 상담이 필요합니다.</p>
        </div>

        <div id="step4" class="step-item info">
            <h3 class="bullet01">임신성 당뇨</h3>
            <p class="depth">
                임신성 당뇨병은 혈당이 정상 범위보다 높은 상태를 말하고 임산부 100명 중 2~3명에서 발생합니다. 
                <br>
                일반적으로 혈당을 낮추는 인슐린의 효과가 감소하는 상태, 즉 인슐린 저항성이 증가되는 상태가 임신 24~28주에 발생하였다가 출산 후에는 사라지는 당뇨병의 한 형태입니다. 이러한 인슐린 저항성은 임신성 당뇨병을 유발하는 원인입니다.
            </p>
            <h4 class="bullet02 type2 num1 depth">진단</h4>
            <p class="bullet04 num1 depth">임신 24~28주에 시행하고 50g 당부하 검사의 기준치를 140mg/dL 이상으로 하는 경우를 선별합니다.</p>
            <p class="bullet04 num2 depth">선별검사 측정 결과 140mg/dL 이상인 경우에는 100g 또는 75g 당부하검사를 시행하게 됩니다. 공복시, 포도당 100g/75g 부하 후 1시간 간격으로 혈당을 측정합니다. 100 g 당부하검사의 경우 4번의 채혈 중 2번 이상의 결과가 기준 초과시, 75 g 당부하검사의 경우 3번 채혈 중 1번 이상의 결과가 기준 초과시 임신성 당뇨병으로 진단합니다.</p>
            <h4 class="bullet02 type2 num2 depth">치료</h4>
            <p class="depth">아기와 산모의 건강을 위해서 임신성 당뇨 산모는 첫 번째로 적적한 혈당유지가 목표입니다. 임신 중 정상적인 혈당은 식전 60~90mg/dL이고, 식후 2시간에는 120mg/dL이하입니다.</p>
            <p class="bullet04 num1 depth">자가 혈당 측정을 통해 혈당을 조절합니다.</p>
            <p class="bullet04 num2 depth">식사요법을 실천합니다.</p>
            <p class="bullet04 num3 depth">운동요법을 실천합니다.</p>
            <p class="bullet04 num4 depth">스트레스 관리를 합니다.</p>
            <p class="depth">정상적인 혈당관리가 되지 않을 경우 산모는 인슐린 주사를 투여하여 혈당관리를 하게 됩니다.</p>
            <h4 class="bullet02 type2 num3 depth">임신성 당뇨병이 태아에게 미치는 영향</h4>
            <p class="bullet04 num1 depth">임신성 당뇨병은 태아기형 유발과는 관계가 없습니다. 그러나 임신성 당뇨병 임산부가 혈당이 높으면 거대아, 신생아 황달, 신생아 저혈당, 호흡곤란증, 저칼륨혈증, 고빌리루빈혈증, 적혈구과다증과 같은 신생아 합병증들의 발생률이 증가합니다.</p>
            <p class="bullet04 num2 depth">임신성 당뇨병은 체중이 4kg이상의 거대아를 분만하게 될 확률이 높아 난산으로 인한 제왕절개의 가능성이 높으며 양수량의 증가로 과다한 양수는 자궁을 긴장시켜 조기진통을 유발 할 수 있습니다. 만약 혈당관리가 안되면 감염발생의 위험이 높아 잦은 요로감염이 나타납니다.</p>
            <h4 class="bullet02 type2 num4 depth">분만 후 관리</h4>
            <p class="depth">
                임신성 당뇨의 산모는 분만 후 대부분 정상혈당으로 유지 할 수 있게 되며 인슐린 주사를 맞은 산모 역시 인슐린이 필요 없게 됩니다. 
                <br>
                그러나 임신성 당뇨 산모의 50%정도는 20년 안에 제2형 당뇨병으로 진행된다는 보고가 있습니다. 그러므로 출산 후 모유수유와 체중관리, 식이조절을 꾸준히 유지하여 당뇨병 발병의 위험을 낮출 수 있습니다.
            </p>
        </div>

        <div id="step5" class="step-item info">
            <h3 class="bullet01">전치태반</h3>
            <p class="depth">
                전치태반이란 태반이 자궁의 출구를 전부 혹은 일부분을 막은 상태를 말하고 자궁 경부가 열리게 되면 혈관이 파열되어 다량의 출혈이 동반될 위험이 높습니다.
            </p>
            <h4 class="bullet02 type2 num1 depth">진단</h4>
            <p class="depth">
                태반의 위치를 알 수 있는 가장 간단하고 정확하며 안전한 방법은 초음파 검사입니다.
            </p>
            <h4 class="bullet02 type2 num2 depth">치료</h4>
            <p class="bullet04 num1 depth">
                전치태반의 경우 가장 특징적인 증상은 통증이 없는 출혈입니다. 그러나, 자궁수축을 동반하는 조기진통과 함께 나타나기도 합니다.
            </p>
            <p class="bullet04 num2 depth">
                임신기간 중 출혈이 발생한다면 산모와 태아의 상태를 가장 먼저 고려하여 가능한 보존적 관리를 하여 출혈이 멈추기를 지켜봅니다. 하지만 과도한 출혈과 태아의 상태가 불안정한 경우 응급제왕절개술을 필요합니다.
            </p>
            <p class="bullet04 num3 depth">
                전치태반의 경우 산전 출혈 뿐아니라 산후 출혈의 중요한 원인이므로 제왕절개술 후 산후출혈에 대한 처치, 응급 수혈과 자궁동맥색전술, 제왕자궁적출술 등이 신속하게 이루어질 수 있는 기관에서 수술하는 것이 안전합니다.
            </p>

            <h4 class="bullet02 type2 num3 depth">분만 후 관리</h4>
            <p class="depth">
                전치태반의 경우 수술을 통하여 출산을 하게 됩니다. 출산 후 자궁하부의 수축이 잘 안되어 출혈이 되는 경우도 발생할 수 있으므로 수술 후 24시간 집중적인 관찰이 필요하게 됩니다.
            </p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">자궁경부무력증</h3>
            <p class="depth">임신 제2삼분기 또는 제3삼분기의 초기에 무통성 자궁경관개대가 있으면서 태막이 질내로 탈출되거나 파열되어 결국 임신손실이 나타나는 질환입니다.</p>
            <h4 class="bullet02 type2 num1 depth">원인</h4>
            <p class="depth">원인은 명확하지 않으나 자궁경부 선천적인 이상이 원인일 수 있고, 대부분 자궁경관의 외상이나 잦은 소파술, 경부절단술, 전기치료, 경부원추절제술이 원인일 수 있습니다.</p>
            <h4 class="bullet02 type2 num2 depth">진단</h4>
            <p class="bullet04 num1 depth">
                <span class="font-main">환자의 과거 산과력이 중요합니다.</span>
            </p>
            <p class="bullet04 num2 depth">'임신중기 이후에 무통성 자궁경관개대가 있으면서 양막파열과 함께 조산된 경우'가 진단에 도움이 됩니다.</p>
            <p class="bullet04 num3 depth">임신 중기 이후에 자궁수축을 동반하거나 혹은 자궁수축은 없으나 조산이나 유산의 경험, 또는 이전에 이런 경험이 없을지라도 초음파검사를 통해 자궁경관이 짧아져 있다면 자궁경관무력증의 위험이 있다고 예측 가능합니다.</p>
            <h4 class="bullet02 type2 num3 depth">치료</h4>
            <p class="depth">
                자궁경부무력증의 수술적 치료로는 자궁경관 원형결찰술을 시행하며, 수술 방법에 따라 Mcdonald와 shirodkar방법이 있습니다. 질식으로 시술이 실패하거나 자궁경관의 질식결찰술을 시행할 수 없을 정도로 짧거나 손상이 심한 경우 복식 자궁경관 원형결찰술을 시행할 수 있습니다.
            </p>
        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">다태임신</h3>
            <p class="depth">
                다태임신은 한번에 둘이상의 태아가 임신되는 것으로 최근 보조생식술의 발달로 다태임신의 빈도는 계속적으로 증가추세에 있습니다. 
                <br>
                가족력 여부를 문진을 통해 확인하고, 진찰시 일반산모보다 큰 배를 보일 수 있습니다. 초음파로 가장 조기에 진단이 가능하며 8-10주에 분리된 2개의 임신낭, 태아주머니를 관찰함으로써 확진할 수 있습니다. 보통 단일임신의 경우는 42주를 지연임신으로 보지만 쌍태아의 경우는 40주를 지연 임신으로 고려하게 됩니다.
            </p>
            <h4 class="bullet02 type2 num1 depth">쌍태 임신에 대한 모체의 적응</h4>
            <p class="bullet04 num1 depth">임신 초기에 입덧이 더 심하고 임신 중에 복용하는 철분과 엽산의 요구량도 더 늘어나게 됩니다.</p>
            <p class="bullet04 num2 depth">유산 가능성이 증가하며 저체중출산, 태아성장지연, 기형률이 증가할 수 있으며 출산 시 빈혈, 조기양막파수를 포함한 조기진통, 임신성고혈압, 자궁경부무력증, 태반조기박리 등이 있습니다.</p>
            <p class="bullet04 num3 depth">분만 중 합병증으로는 자궁기능부전, 유착태반이 있고 산후 합병증으로는 산후출혈이 있습니다.</p>

            <h4 class="bullet02 type2 num2 depth">다태임신의 합병증</h4>
            <p class="bullet04 num1 depth">자연유산, 태아 사망</p>
            <p class="bullet05 depth">다태임신에서 임신 제1삼분기 이내의 유산의 위험성은 약 14%로 이는 단태임신의 유산의 위험성의 약 세배에 해당되며 태아의 수가 많을수록 자연유산율은 높아집니다.</p>
            <p class="bullet04 num2 depth">전자간증</p>
            <p class="bullet05 depth">단태임신에 비해 약 2-3배 많이 그리고 더 빨리 생기고, 임신성 고혈압으로 인한 조산, 태아발육지연, 태반 조기박리과 같은 합병증이 증가하며 신생아 합병증 발생 위험도 높습니다.</p>
            <p class="bullet04 num3 depth">조산</p>
            <p class="bullet05 depth">국내 보고에서는 쌍태아의 경우 57% 조산하고 임신 평균주수 35주, 삼태아의 경우 92% 조산하고 임신 평균주수 32주입니다.</p>
            <p class="bullet04 num4 depth">분만 합병증</p>
            <p class="bullet05 depth">
                다태임신으로 인해 크게 늘어난 자궁 근육은 분만후 수축력이 약해서 진통 중에는 진통이 충분하지 않고, 출산 후에는 이완성 자궁 출혈의 가능성이 높습니다. 따라서 출산전에 응급 상황에 대비할 수혈 준비를 충분히 해야합니다. 
                <br>
                그 외에 여러 가지 이유로 산모와 태아의 응급상황이 발생할 확률이 높습니다. 따라서 응급상황과 수술에 대비한 준비와 의료진이 준비되어 있어야 되며 조산한 태아 상태가 나쁠 때를 대비하여 처치가 가능한 의료환경에서 산전관리를 받는 것은 매우 중요합니다.
            </p>
        </div>

        <div id="step8" class="step-item info">
            <h3 class="bullet01">태아치료</h3>
            <p class="depth">
                최근 환경 호르몬이나 대기오염 등의 영향으로 태아 기형이 증가함에 따라 한국에서 태어나는 신생아의 약 3~4% 정도가 크고 작은 선천성 기형을 갖고 태어나고 있습니다.
                <br>
                이대서울병원 태아치료팀은 고해상도의 정밀 초음파를 이용한 정확한 태아 이상 진단을 비롯하여, 태아의 내과적 치료 및 흉수, 복수, 방광천자술을 비롯한 태아단락술, 태아 빈혈에 대한 태아 수혈, 태아 내시경을 통한 레이저 치료 및 고주파 융해술 등의 외과적 치료와 분만 중 태아 치료 등 다양한 진단 및 치료법을 활용해 국내 최상위 수준의 태아 치료를 시행하고 있습니다.
                <br>
                어떠한 결함이 있는 자궁 내의 태아에게 출산 이전에 필요한 시술을 하여 태아의 기형 또는 질환의 진행을 중지시켜 최선의 결과를 도모하는 방법으로, 최근 몇몇 선천성 기형에 대해 시도되고 있는 치료법입니다. 태아 치료는 매우 제한적으로만 적용될 수 있으므로 몇 가지 조건을 만족해야 합니다.
            </p>
            <h4 class="bullet02 type2 num1 depth">태아치료의 조건</h4>
            <p class="bullet04 num1 depth">자궁 내 치료를 통해 태아 기형의 병인을 교정할 수 있어야 합니다.</p>
            <p class="bullet04 num2 depth">정확하게 진단하여 기형의 진행 정도를 평가할 수 있어야 합니다.</p>
            <p class="bullet04 num3 depth">선천성 기형의 자연 경과 및 예후에 관한 이해가 확립되어 있어야 합니다.</p>
            <p class="bullet04 num4 depth">생후에 치료를 시도하여도 이미 비가역적인 손상을 받게 되므로 반드시 태아기 치료가 필요한 경우여야 합니다.</p>
            <p class="bullet04 num5 depth">동물 실험에서 효과가 증명되어야 합니다.</p>
            <p class="bullet04 num6 depth">엄격하게 계획된 태아 치료 센터에서 시행되어야 합니다.</p>
            <p class="bullet04 num7 depth">충분한 정보를 임신부와 그 남편에게 제공하여 승낙서를 받아야 합니다.</p>

            <h4 class="bullet02 type2 num2 depth">태아치료의 종류</h4>
            <p class="depth">태아 치료에는 태아를 위해 모체에 약물을 투여하는 내과적 치료와 태아에게 직접 침습적 시술을 하는 수술적 치료가 있습니다.</p>
            <p class="bullet04 num1 depth">내과적 치료의 대상에는 태아의 갑상선 이상이나 부신 비대증, 부정맥 등이 있습니다.</p>
            <p class="bullet04 num2 depth">침습적 시술에는 태아 수혈, 태아 단락 수술, 개방형 태아 수술 등이 있고, 적응증에는 쌍태간 수혈 증후군, 선천성 횡격막 탈장, 천미골 기형종, 선천성 폐낭성 유선종과 폐분리증, 수막척수류 등이 있습니다. </p>
        </div>

        <div id="step9" class="step-item info">
            <h3 class="bullet01">산후 출혈</h3>
            <p class="depth">
                산후 출혈이란 출산 후 500cc 이상의 과량의 출혈이 있는 경우를 말하며 직접적인 원인은 대부분 자궁 수축 부전으로 인한 이완성 자궁출혈입니다. 그 외에 혈액응고 장애, 잔류태반, 유착태반, 자궁파열, 산도열상이 있습니다.
            </p>
            <h4 class="bullet02 type2 num1 depth">자궁이완증(uterine atony)</h4>
            <p class="bullet04 num1 depth">자궁이완증(uterine atony)이 발생한 경우, 처음에 자궁저부 마사지와 내과적 치료로 옥시토신, methylergonovine같은 ergot 유도체, 프로스타글란딘, 카르베토신(carbetocin)을 사용할 수 있습니다.</p>
            <p class="bullet04 num2 depth">그러나 자궁수축제에 반응하지 않고 출혈이 지속되는 경우는 복부 및 질을 통하여 양손으로 자궁을 압박함(bimanual compression)과 동시에 수액공급 및 수혈을 하고, 외과적 처치, 즉, 자궁동맥(uterine artery) 결찰술, 내장골동맥(hypogastric artery) 결찰술, 자궁내 충전, 자궁 압박 봉합 기술, 혈관조영 색전술, 자궁적출술 등을 해야합니다.</p>

            <h4 class="bullet02 type2 num2 depth">동맥결찰술</h4>
            <p class="depth">
                동맥결찰술은 특별한 합병증이 없고 향후 정상적인 생리와 임신이 가능한 것으로 알려져 있는데, 자궁동맥 결찰술의 경우 임신중 자궁혈액공급의 90%를 담당하는 혈관이 차단되기 때문에 산후출혈을 효과적으로 조절할 수 있고 자궁측벽을 따라 자궁동맥의 상행분지를 자궁근층과 같이 결찰하게 되므로 내장골동맥 결찰술에 비해 간단하고 안전한 장점이 있습니다.
            </p>
            <h4 class="bullet02 type2 num3 depth">자궁적출술</h4>
            <p class="depth">
                자궁적출술은 향후 임신이 불가능하고 영구적인 무월경 상태가 되어 산후 우울증의 가능성이 높으며 대량출혈과 수술적 합병증을 일으킬 수 있습니다.
            </p>
        </div>
    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>